// apps/codeframe/src/motion/mathAdapter.ts
import { cubicBezier, spring, mixColor as motionMixColor } from 'motion';

export function lerp(a: number, b: number, p: number): number {
  return a + (b - a) * p;
}

export function cubicBezierFn(x1: number, y1: number, x2: number, y2: number): (p: number) => number {
  return cubicBezier(x1, y1, x2, y2);
}

export function springFn(opts: { stiffness?: number; damping?: number; mass?: number }): (p: number) => number {
  // motion.dev spring generates values over time (ms), not over progress [0,1].
  // We sample by mapping p→t using a scanned total duration.
  // Defensive: never throws even if the spring generator shape varies by version.
  const s: any = spring({
    stiffness: opts.stiffness ?? 100,
    damping: opts.damping ?? 10,
    mass: opts.mass ?? 1,
    keyframes: [0, 1],
  } as any);

  // calculatedDuration is null for underdamped springs; scan for it.
  let total: number = (s && typeof s.calculatedDuration === 'number' && s.calculatedDuration) || 0;
  if (!total && s && typeof s.next === 'function') {
    let t = 10;
    while (t <= 10000) {
      const r = s.next(t);
      if (r && r.done) { total = t; break; }
      t += 10;
    }
    if (!total) total = 1000; // safe default
  }
  if (!total) total = 1;

  return (p: number) => {
    const pp = Math.max(0, Math.min(1, p));
    if (s && typeof s.next === 'function') {
      const r = s.next(pp * total);
      return (r && typeof r.value === 'number') ? r.value : pp;
    }
    if (typeof s === 'function') return s(pp);
    return pp; // last-resort linear fallback; never throw
  };
}

export function mixColor(a: string, b: string): (p: number) => string {
  return motionMixColor(a, b) as (p: number) => string;
}
